function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import router from 'next/router';
import NProgress from 'nprogress';
import '../styles/global.scss';
import '@fortawesome/fontawesome-svg-core/styles.css';
import './nprogress.scss';
import '@stripe/stripe-js';
import { Provider } from 'next-auth/client'; // progress bar events
router.events.on('routeChangeStart', function() {
    return NProgress.start();
});
router.events.on('routeChangeComplete', function() {
    return NProgress.done();
});
router.events.on('routeChangeError', function() {
    return NProgress.done();
});
export default function App(props) {
    var Component = props.Component, pageProps = props.pageProps;
    var err = props.err;
    return /*#__PURE__*/ _jsx(Provider, {
        session: pageProps.session,
        children: /*#__PURE__*/ _jsx(Component, _objectSpread({}, pageProps, {
            err: err
        }))
    });
};
